<template>
  <div class="price-overlay-wrapper margin-bottom-m">
    <div
      v-if="price.flags.isShowPriceTypeText"
      class="label normal"
    >
      {{ price.priceType.text }}
    </div>

    <div class="capitalized">
      <div
        v-if="price.priceType.showFinalOfferText"
        class="gray"
      >
        {{ price.priceType.text }}
      </div>

      <div v-if="price.tieredPrice[2]">
        <span class="prev-price">
          {{ price.tieredPrice[2].label }} {{ price.tieredPrice[2].values[0]?.formattedValue }}
        </span>
      </div>

      <div v-if="price.tieredPrice[1]">
        <span class="prev-price">
          {{ price.tieredPrice[1].label }} {{ price.tieredPrice[1].values[0]?.formattedValue }}
        </span>
      </div>

      <div
        v-if="price.tieredPrice[0]"
        :class="{'red':price.priceType.onSale && !price?.finalPrice?.formattedFinalPrice}"
      >
        <span :class="{'bold':price.priceType.onSale && !price?.finalPrice?.formattedFinalPrice}">
          {{ price.tieredPrice[0].label }} {{ price.tieredPrice[0].values[0]?.formattedValue }}
        </span>
        <span v-if="price.tieredPrice[0].values[0]?.percentOff"> ({{ price.tieredPrice[0].values[0]?.percentOff?.[0] }}% off) </span>
        <span
          v-if="price.priceType.saleEnds"
          class="gray"
        >
          {{ price.priceType.saleEnds }}
        </span>
      </div>
      <div
        v-if="price?.finalPrice?.formattedFinalPrice"
        class="red bold"
      >
        {{ price.finalPrice.formattedFinalPrice }}
        <span v-if="price.finalPrice?.values?.[0]?.percentOff?.[0]"> ({{ price.finalPrice.values[0].percentOff[0] }}% off)</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { PRICE_OVERLAY_DATA } from './constants';

const price = inject(PRICE_OVERLAY_DATA);
</script>

<style lang="scss" scoped>
.gray {
  color: $gray-1-color;
}
.red {
  color: $sale-color;
}
.capitalized {
  text-transform: capitalize;
}
.bold {
  font-weight: 500;
}
</style>
